const container = "_j0jcx0w28k";
const heading = "_j0jh1u5tuli";
const guide = "_j0jg1yf1hp7";

export { container, guide, heading };
import "./empty.style.linaria.module.css";
//# sourceMappingURL=empty.style.js.map
